// file: redux/actions/fullReport.js
import {SET_FULL_REPORT} from './types';

// Sets the full array of reports
export const setFullReport = (monthlyReport: any[]) => ({
  type: SET_FULL_REPORT,
  payload: monthlyReport,
});

// Async thunk to dispatch the bulk set (can be extended for real API calls)
export const setFullReports = (fullReport: any[]) => {
  return async (dispatch: any) => {
    try {
      dispatch(setFullReport(fullReport));
    } catch (error: any) {
      console.error('Error dispatching full reports:', error);
    }
  };
};

// Action for per-statistic-ID caching:
export const storeReportById = (statisticId: string, report: any) => ({
  type: 'STORE_REPORT_BY_ID',
  payload: {statisticId, report},
});

// NEW: Action for per-class-ID caching:
export const storeClassReport = (classId: string, report: any) => ({
  type: 'STORE_CLASS_REPORT',
  payload: {classId, report},
});

// Action for school attendance caching by school-month key:
export const storeSchoolAttendance = (cacheKey: string, report: any) => ({
  type: 'STORE_SCHOOL_ATTENDANCE',
  payload: {cacheKey, report},
});

// Action for school aggregated data (all classes performance):
export const storeSchoolAggregatedData = (schoolId: string, data: any) => ({
  type: 'STORE_SCHOOL_AGGREGATED_DATA',
  payload: {schoolId, data},
});

// Action for class statistics caching (phonetics & syllables):
export const storeClassStatistics = (classId: string, statistics: any) => ({
  type: 'STORE_CLASS_STATISTICS',
  payload: {classId, statistics},
});

// Action for school reports summary caching by school-month key:
export const storeSchoolReportsSummary = (cacheKey: string, report: any) => ({
  type: 'STORE_SCHOOL_REPORTS_SUMMARY',
  payload: {cacheKey, report},
});

// Action to add a school monthly report to the array with selected flag
export const addSchoolMonthlyReport = (report: any, selected: boolean = false) => ({
  type: 'ADD_SCHOOL_MONTHLY_REPORT',
  payload: {report, selected},
});

// Action to set which monthly report is selected (by month)
export const setSelectedMonthlyReport = (month: string) => ({
  type: 'SET_SELECTED_MONTHLY_REPORT',
  payload: {month},
});

// Action to add a class monthly report array to Redux cache with selected flag
export const addClassMonthlyReportArray = (month: string, reports: any[], selected: boolean = false) => ({
  type: 'ADD_CLASS_MONTHLY_REPORT_ARRAY',
  payload: {month, reports, selected},
});

// Action to set which class monthly report month is selected
export const setSelectedClassMonthlyReportMonth = (month: string) => ({
  type: 'SET_SELECTED_CLASS_MONTHLY_REPORT_MONTH',
  payload: {month},
});

// Excludes current month from caching (always fetch fresh)
export const storeClassMonthlyReportByMonth = (classId: string, month: string, report: any) => ({
  type: 'STORE_CLASS_MONTHLY_REPORT_BY_MONTH',
  payload: {classId, month, report},
});

// Action for student monthly report caching by studentId-month key
// Excludes current month from caching (always fetch fresh)
export const storeStudentMonthlyReportByMonth = (studentId: string, month: string, report: any) => ({
  type: 'STORE_STUDENT_MONTHLY_REPORT_BY_MONTH',
  payload: {studentId, month, report},
});
